import { useEffect, useState } from "react";

export const useResizeDirection = (
    titleRef: React.RefObject<HTMLDivElement>,
    subtitleRef: React.RefObject<HTMLDivElement>,
    initialDirection: "horizontal" | "vertical",
): "horizontal" | "vertical" => {
    const [currentDirection, setCurrentDirection] = useState(initialDirection);

    const maxTextHeight = 40;

    useEffect(() => {
        const checkTextHeight = () => {
            let shouldSwitch = false;

            if (titleRef.current) {
                shouldSwitch = titleRef.current.clientHeight >= maxTextHeight;
            }

            if (subtitleRef.current && !shouldSwitch) {
                shouldSwitch =
                    subtitleRef.current.clientHeight >= maxTextHeight;
            }

            if (shouldSwitch) {
                setCurrentDirection("vertical");
            }
        };

        const resizeObserver = new ResizeObserver(checkTextHeight);

        if (titleRef.current) {
            resizeObserver.observe(titleRef.current);
        }

        if (subtitleRef.current) {
            resizeObserver.observe(subtitleRef.current);
        }

        checkTextHeight();

        return () => {
            resizeObserver.disconnect();
        };
    }, [titleRef, subtitleRef, currentDirection, initialDirection]);

    return currentDirection;
};
